export default (function (response, successCallback, errorCallback) {
    if (errorCallback === void 0) { errorCallback = function (x) { return x; }; }
    if (response.data.hasError) {
        return errorCallback(response);
    }
    else {
        return successCallback(response.data);
    }
});
//# sourceMappingURL=validateResponse.js.map